/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Slider, SliderSkeleton } from 'carbon-components-react';
import React, { useEffect, useState } from 'react';

interface ControlledSliderVoiceSelectorProps {
  className: string;
  defaultValue: number;
  id: string;
  instanceLoaded: Boolean;
  labelText: string;
  maxValue: number;
  minValue: number;
  onChange: Function;
  stepValue: number;
}

const ControlledSliderVoiceSelector = (
  props: ControlledSliderVoiceSelectorProps
) => {
  const {
    className,
    defaultValue,
    id,
    instanceLoaded,
    labelText,
    maxValue,
    minValue,
    onChange,
    stepValue
  } = props;
  const [selectedValue, setSelectedValue] = useState<number>();

  useEffect(() => {
    if (typeof defaultValue === 'number' && !isNaN(defaultValue)) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      {instanceLoaded ? (
        <div className={`${className}-container`}>
          <Slider
            id={`slider-${id}`}
            ariaLabelInput={labelText}
            labelText={labelText}
            max={maxValue}
            min={minValue}
            onChange={({ value }) => {
              const fixedValue = Number(value.toFixed(2));
              setSelectedValue(fixedValue);
            }}
            onRelease={({ value }) => {
              const fixedValue = Number(value.toFixed(2));
              setSelectedValue(fixedValue);
              onChange(fixedValue);
            }}
            onKeyDown={event => {
              if (event.key === 'ArrowLeft' && selectedValue > minValue) {
                if (selectedValue - stepValue < minValue) {
                  setSelectedValue(minValue);
                }
                setSelectedValue(selectedValue - stepValue);
              } else if (
                event.key === 'ArrowRight' &&
                selectedValue < maxValue
              ) {
                if (selectedValue + stepValue > maxValue) {
                  setSelectedValue(maxValue);
                }
                setSelectedValue(selectedValue + stepValue);
              }
            }}
            step={stepValue}
            value={selectedValue}
          />
        </div>
      ) : (
        <SliderSkeleton />
      )}
      <div className="TabContent__spacer32" />
    </>
  );
};

export { ControlledSliderVoiceSelector };
